export default "__VITE_ASSET__DFP2H5Nd__"